import React, { ChangeEvent, useState } from 'react';
import { BsSearch } from 'react-icons/bs';
import { FaArrowLeft } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { warnToast } from '../../utils/toast';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import { Container, Message, SearchContainer, SearchInput } from './styles';

const BuscaPlaca: React.FC = () => {
  const { handleReturnCurrentStep, searchPlate, car } = useSteps();

  const [plate, setPLate] = useState('');

  const [searched, setSearched] = useState(false);

  const handlePlacaChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPLate(e.target.value.toUpperCase());
  };

  const validatePlateLenght = () => {
    if (plate.length !== 7) {
      warnToast('Por favor digite a placa corretamente EX: BLZ1234');
      return;
    }
    searchPlate(plate);
    setSearched(true);
  };

  return (
    <Content>
      <GoBack onClick={handleReturnCurrentStep}>
        <FaArrowLeft size={16} />
        voltar
      </GoBack>
      <Title>Buscar Veículo por Placa</Title>
      <Container>
        <SearchContainer>
          {searched && !car.car_id && (
            <>
              <Message>A placa não existe em nosso sistema,</Message>
              <Message>
                por favor verifique se foi digitado corretamente
              </Message>
            </>
          )}
          <Message>
            Tentaremos encontrar uma ocorrencia para sua pesquisa
          </Message>
          <SearchInput
            placeholder="Digite a Placa aqui. Ex:'BLZ1234'"
            autoFocus
            value={plate}
            onChange={handlePlacaChange}
          />
        </SearchContainer>
      </Container>
      <Button title="Buscar" onClick={validatePlateLenght} icon={BsSearch} />
    </Content>
  );
};

export default BuscaPlaca;
